const $ = window.jQuery;

import errorManager from '@/rollbar.js';

const setListener = () => {
  // Salvataggio esecuzione da modale
  $('#execute-deadlines-calendar').click(function (e) {
    var $link, activitiesDeadlineEl, event;
    $link = $(e.target);
    e.preventDefault();
    if (!$link.data('lockedAt') || +new Date() - $link.data('lockedAt') > 1500) {
      $('#form-deadlines-calendar').submit();
    }
    $link.data('lockedAt', +new Date());
    event = new Event('calendarDeadlineRefetch');
    activitiesDeadlineEl = document.getElementById('calendar_deadlines');
    if (activitiesDeadlineEl) {
      activitiesDeadlineEl.dispatchEvent(event);
    }
  });
};

const init = () => {
  try {
    setListener();
  } catch (e) {
    errorManager(e);
  }
};

window.DeadlinesCalendar = {
  init: init,
};
